/**
 * @generated SignedSource<<cb645df21d26715f826e58b7329ffbce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubEnrolmentModelStatusChoices = "ARCHIVED" | "ENROLED" | "OFFERED" | "WAITING_LIST" | "%future added value";
export type EditEnrolmentInput = {
  adminNotes?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  enrolmentId: string;
  instrument?: string | null | undefined;
  lessonStage?: string | null | undefined;
  lessonType?: string | null | undefined;
  parentEmail?: string | null | undefined;
  parentName?: string | null | undefined;
  parentPhoneNumber?: string | null | undefined;
  positionInWaitingList?: number | null | undefined;
  pupilFirstName?: string | null | undefined;
  pupilLastName?: string | null | undefined;
  pupilNotes?: string | null | undefined;
  schoolClass?: string | null | undefined;
  schoolId?: string | null | undefined;
  schoolYear?: number | null | undefined;
  status?: string | null | undefined;
};
export type EditEnrolmentMutation$variables = {
  input: EditEnrolmentInput;
};
export type EditEnrolmentMutation$data = {
  readonly editEnrolment: {
    readonly enrolment: {
      readonly adminNotes: string | null | undefined;
      readonly archivedTimestamp: string | null | undefined;
      readonly createdTimestamp: string | null | undefined;
      readonly enroledTimestamp: string | null | undefined;
      readonly hasInvalidParentPhoneNumber: boolean;
      readonly id: string;
      readonly instrument: string | null | undefined;
      readonly lastOfferedTimestamp: string | null | undefined;
      readonly lessonStage: string | null | undefined;
      readonly lessonType: string | null | undefined;
      readonly offers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly archived: boolean;
            readonly id: string;
            readonly offerAccepted: boolean;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly parentEmail: string | null | undefined;
      readonly parentName: string | null | undefined;
      readonly parentPhoneNumber: string | null | undefined;
      readonly positionInWaitingList: number | null | undefined;
      readonly pupilFirstName: string | null | undefined;
      readonly pupilLastName: string | null | undefined;
      readonly pupilNotes: string | null | undefined;
      readonly school: {
        readonly id: string;
      } | null | undefined;
      readonly schoolClass: string | null | undefined;
      readonly schoolYear: number | null | undefined;
      readonly status: PianofunclubEnrolmentModelStatusChoices;
    } | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
    readonly updatedEnrolmentsInWaitingList: ReadonlyArray<{
      readonly id: string;
      readonly positionInWaitingList: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type EditEnrolmentMutation = {
  response: EditEnrolmentMutation$data;
  variables: EditEnrolmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionInWaitingList",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditEnrolmentPayload",
    "kind": "LinkedField",
    "name": "editEnrolment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentNode",
        "kind": "LinkedField",
        "name": "enrolment",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SchoolNode",
            "kind": "LinkedField",
            "name": "school",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pupilFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pupilLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schoolYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schoolClass",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instrument",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lessonStage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lessonType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parentName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parentEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parentPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasInvalidParentPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminNotes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pupilNotes",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enroledTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archivedTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastOfferedTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrolmentOfferNodeConnection",
            "kind": "LinkedField",
            "name": "offers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EnrolmentOfferNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EnrolmentOfferNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "offerAccepted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "archived",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentNode",
        "kind": "LinkedField",
        "name": "updatedEnrolmentsInWaitingList",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditEnrolmentMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditEnrolmentMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7fdbbef41987b59e98ec9c6cd53b1bbd",
    "id": null,
    "metadata": {},
    "name": "EditEnrolmentMutation",
    "operationKind": "mutation",
    "text": "mutation EditEnrolmentMutation(\n  $input: EditEnrolmentInput!\n) {\n  editEnrolment(input: $input) {\n    success\n    errors\n    enrolment {\n      id\n      school {\n        id\n      }\n      pupilFirstName\n      pupilLastName\n      schoolYear\n      schoolClass\n      instrument\n      lessonStage\n      lessonType\n      parentName\n      parentEmail\n      parentPhoneNumber\n      hasInvalidParentPhoneNumber\n      adminNotes\n      pupilNotes\n      positionInWaitingList\n      status\n      createdTimestamp\n      enroledTimestamp\n      archivedTimestamp\n      lastOfferedTimestamp\n      offers {\n        edges {\n          node {\n            id\n            offerAccepted\n            archived\n          }\n        }\n      }\n    }\n    updatedEnrolmentsInWaitingList {\n      id\n      positionInWaitingList\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "65cae1d9ed315c2f28fa1e6a32ed39ef";

export default node;
